import React, { useState, useEffect } from "react";

const NewsSection = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [current, setCurrent] = useState(0);

  // Fetch news from API
  useEffect(() => {
    fetch("https://gp-chandoli-khurd.com/backend/api/news/get_news.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success" && Array.isArray(data.news)) {
          setNewsItems(data.news.map((item) => item.title));
        } else {
          console.error("Error fetching news:", data.message);
        }
      })
      .catch((err) => console.error("Fetch error:", err));
  }, []);

  // Auto change news every 5 sec
  useEffect(() => {
    if (newsItems.length === 0) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % newsItems.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [newsItems]);

  if (newsItems.length === 0) {
    return (
      <div className="w-full flex bg-custom-orange border-y border-gray-500 h-12 items-center justify-center text-black font-bold">
        Loading news...
      </div>
    );
  }

  return (
    <div className="w-full flex bg-custom-orange border-y border-gray-500 h-12 overflow-hidden">
      {/* Left Side Div */}
      <div className="w-1/6 flex items-center justify-center bg-bg_orange text-black font-bold text-sm md:text-base border-r border-gray-900">
        बातम्या
      </div>

      {/* Right Side Scroller */}
      <div className="w-5/6 flex items-center overflow-hidden relative">
        <div
          key={current}
          className="whitespace-nowrap absolute animate-scroll text-black text-sm md:text-base px-4"
        >
          {newsItems[current]}
        </div>
      </div>
    </div>
  );
};

export default NewsSection;